<div class="overlaySpinner">
  <div class="spinner">
    <div class="bounce5"></div>
    <div class="bounce4"></div>
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
  </div>
</div>
